module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, _vm._l(([true, false]), function(isRequired) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (isRequired || (!isRequired && _vm.showOptionalAttributes)),
        expression: "isRequired || (!isRequired && showOptionalAttributes)"
      }]
    }, [(_vm.variation.leroyAttributes.some(function (attr) { return attr.required === isRequired; })) ? _c('div', {
      staticClass: "divider"
    }, [_c('span', [_vm._v("Atributos " + _vm._s(isRequired ? 'obrigatórios' : 'opcionais'))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "l-row"
    }, [(!isRequired) ? _c('form-group', {
      attrs: {
        "label": _vm.$t("crossDocking.label"),
        "columns": 3,
        "error": _vm.getError('crossDocking', _vm.variation.sku)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.variation.crossDocking),
        expression: "variation.crossDocking"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "number",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (_vm.variation.crossDocking)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.variation, "crossDocking", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.variation.leroyAttributes.filter(function (attr) { return attr.required === isRequired; })), function(attribute) {
      return _c('form-group', {
        key: attribute.code,
        attrs: {
          "required": attribute.required,
          "label": attribute.label,
          "columns": 3,
          "error": _vm.getError(attribute.code, _vm.variation.sku)
        }
      }, [(attribute.type === 'LIST' || attribute.code === 'seal') ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (attribute.value),
          expression: "attribute.value"
        }],
        staticClass: "form-select",
        attrs: {
          "disabled": _vm.disabledInputs()
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(attribute, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((attribute.options), function(option) {
        return (attribute.code !== 'seal') ? _c('option', {
          domProps: {
            "value": option.code
          }
        }, [_vm._v(_vm._s(option.label))]) : _vm._e()
      }), _vm._v(" "), _vm._l((_vm.variation.images), function(image, index) {
        return (attribute.code === 'seal') ? _c('option', {
          domProps: {
            "value": image
          }
        }, [_vm._v("Imagem: " + _vm._s(index + 1))]) : _vm._e()
      })], 2) : (attribute.type === 'INTEGER') ? _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('###'),
          expression: "'###'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (attribute.value),
          expression: "attribute.value"
        }],
        staticClass: "form-input",
        attrs: {
          "type": "text",
          "disabled": _vm.disabledInputs(),
          "min": "0"
        },
        domProps: {
          "value": (attribute.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(attribute, "value", $event.target.value)
          }
        }
      }) : (attribute.type === 'DECIMAL') ? _c('input', {
        directives: [{
          name: "mask",
          rawName: "v-mask",
          value: ('###.##'),
          expression: "'###.##'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (attribute.value),
          expression: "attribute.value"
        }],
        staticClass: "form-input",
        attrs: {
          "type": "text",
          "disabled": _vm.disabledInputs(),
          "min": "0"
        },
        domProps: {
          "value": (attribute.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(attribute, "value", $event.target.value)
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (attribute.value),
          expression: "attribute.value"
        }],
        staticClass: "form-input",
        attrs: {
          "type": "text",
          "disabled": _vm.disabledInputs()
        },
        domProps: {
          "value": (attribute.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(attribute, "value", $event.target.value)
          }
        }
      }), _vm._v(" "), (attribute.code === 'seal') ? _c('small', {
        staticClass: "form-help"
      }, [_vm._v("Você deve escolher o número da imagem correspondente ao selo do inmetro deste produto.")]) : _vm._e()])
    }), _vm._v(" "), (isRequired) ? _c('div', {
      staticClass: "l-col-12 toggle-more"
    }, [_c('span', {
      staticClass: "btn--sm btn--info",
      on: {
        "click": function () { return _vm.showOptionalAttributes = !_vm.showOptionalAttributes; }
      }
    }, [_vm._v("\n          " + _vm._s(!_vm.showOptionalAttributes ? 'Exibir atributos opcionais' : 'Esconder atributos opcionais') + "\n        ")])]) : _vm._e()], 2)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0fb743","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/leroy/provide/Variation.vue
// module id = 3013
// module chunks = 0